import { FunctionComponent, useContext } from 'react'
import { Helmet } from 'react-helmet';
import { CustomThemeContext } from '../context/theme/custom-theme-context';

export const MetaTagProvider: FunctionComponent<{ metaTitle: string; metaDescription: string; removeName?: boolean }> = ({ metaTitle, metaDescription, removeName = false }) => {
  const customThemeProvider = useContext(CustomThemeContext);

  return (<>
    <Helmet>
      <meta charSet="utf-8" />
      {metaTitle && <title>{removeName ? '' : customThemeProvider.partnerName}{removeName ? '' : ' | '}{metaTitle}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
    </Helmet>
  </>)
}